import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { useGetHistoryDisabledState } from 'app/modules/wallforming/components/placement-history/hooks/useGetHistoryDisabledState';
import { HistoryDialog } from 'app/modules/wallforming/components/placement-history/types/historyDialog';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const RepeatHistory = () => {
    const { t } = useTranslation();
    const disabled = useGetHistoryDisabledState();
    
    const { repeatCount, setHistoryDialog } = usePlacementStore(
        useShallow((state) => ({
            repeatCount: state.repeatHistory.length,
            setHistoryDialog: state.setHistoryDialog
        }))
    );

    return (
        <Menu.Item
            disabled={disabled || repeatCount === 0}
            leftSection={<Icon aria-hidden="true" icon="history" />}
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralRepeatHistory} />}
            onClick={() => setHistoryDialog(HistoryDialog.REPEAT)}
        >
            {t('repeatHistory')}
        </Menu.Item>
    );
};
